import type { VoicePart } from './model';

const VOICE_WORDS: Record<string, VoicePart> = {
  s: 'S',
  sop: 'S',
  sopr: 'S',
  soprano: 'S',
  sopranos: 'S',
  soprani: 'S',
  sopran: 'S',
  a: 'A',
  alt: 'A',
  alto: 'A',
  altos: 'A',
  alti: 'A',
  contralto: 'A',
  t: 'T',
  ten: 'T',
  tenor: 'T',
  tenors: 'T',
  tenore: 'T',
  tenori: 'T',
  b: 'B',
  bas: 'B',
  bass: 'B',
  basses: 'B',
  basso: 'B',
  bassi: 'B',
  bar: 'B',
  bariton: 'B',
  baritone: 'B',
  baritono: 'B',
};

/** Lower-case, fold the Turkish dotted and dotless i, strip accents, keep letters only. */
export function normalizeName(name: string): string[] {
  const folded = name
    .replace(/[İIı]/g, 'i')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
  return folded
    .replace(/[^a-z]+/g, ' ')
    .trim()
    .split(' ')
    .filter((t) => t !== '');
}

/**
 * Match a staff name such as "Soprano", "S.", "Alto 1", "Tenor", "Bas" or "Bariton" to a voice part.
 * Tries each name in turn. Returns null when nothing matches, or when a name names several
 * parts ("Soprano Alto").
 */
export function matchVoicePart(...names: string[]): VoicePart | null {
  for (const name of names) {
    const found = new Set<VoicePart>();
    for (const token of normalizeName(name)) {
      const part = VOICE_WORDS[token];
      if (part) found.add(part);
    }
    if (found.size === 1) return [...found][0] as VoicePart;
    if (found.size > 1) return null;
  }
  return null;
}
